import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { noop } from 'lodash'
import { Dropdown, Icon } from '@adc/ui-adc'
import {
  SORT_TYPES,
  SORT_ORDERS,
  ARVSortOptionsOrder,
} from '../../constants/sorting'
import { getSortOrderIcon } from '../../util/sorting'

class SortDropdown extends Component {
  static propTypes = {
    elmId: PropTypes.string,
    direction: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    selectedDirection: PropTypes.string,
    selectedValue: PropTypes.string,
    featureFlags: PropTypes.object,
    title: PropTypes.node,
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
    selection: PropTypes.bool,
  }

  static defaultProps = {
    onOpen: noop,
    onClose: noop,
    title: null,
    selection: false,
    featureFlags: null,
    direction: 'right',
    selectedDirection: SORT_ORDERS.asc,
    selectedValue: SORT_TYPES.default,
  }

  onDropdownClick = (_, data) => {
    this.props.onSelect(data.value)
  }

  getSortIcon = sortOption => {
    const { selectedDirection, selectedValue } = this.props
    let headerIcon
    if (sortOption.value === selectedValue) {
      headerIcon = <Icon name={getSortOrderIcon(selectedDirection)} />
    }
    return (
      <span>
        {sortOption.text} {headerIcon}
      </span>
    )
  }

  getDropdownItems = () =>
    ARVSortOptionsOrder.map((sortOption, i) => (
      <Dropdown.Item
        data-elm-id={`${this.props.elmId}_sort_dropdown_${sortOption.value}`}
        icon={this.getSortIcon(sortOption)}
        onClick={this.onDropdownClick}
        key={i}
        value={sortOption.value}
      />
    ))

  render() {
    const {
      direction,
      elmId,
      title,
      onOpen,
      onClose,
      selection,
      selectedValue,
      selectedDirection,
      featureFlags,
      ...rest
    } = this.props // eslint-disable-line no-unused-vars
    const sortOption = ARVSortOptionsOrder.find(sortOption => {
      return sortOption.value === selectedValue
    })

    const text = this.getSortIcon(sortOption)
    return (
      <Dropdown
        data-elm-id={`${elmId}_sort_dropdown`}
        icon={title}
        direction={direction}
        onOpen={onOpen}
        onClose={onClose}
        {...(selection ? { selection, text, fluid: true } : {})}
        {...rest}
      >
        <Dropdown.Menu>{this.getDropdownItems()}</Dropdown.Menu>
      </Dropdown>
    )
  }
}

export default SortDropdown
